import type { EnvironmentVariablesConfig } from 'features/environment/interfaces';
import { sipSettings } from 'features/sip/config';

type SipOnlyEnvironmentConfig = Pick<EnvironmentVariablesConfig, 'sip'>;

export const updateSipConfig = (config: Partial<SipOnlyEnvironmentConfig>) => {
  if (!config.sip) {
    return;
  }

  const sipConfig = sipSettings.get();
  const {
    turnServer,
    stunServer,
    stunServerAlt,
    iceServerCredential,
    iceServerUsername,
  } = config.sip;

  const stunServers = [stunServer, stunServerAlt].filter(
    (server): server is string => Boolean(server)
  );

  const iceServers: RTCIceServer[] = [
    ...(turnServer
      ? [
          {
            urls: [turnServer],
            credential: iceServerCredential,
            username: iceServerUsername,
          },
        ]
      : []),
    ...(stunServers.length
      ? [
          {
            urls: stunServers,
          },
        ]
      : []),
  ];

  sipSettings.update({
    domain: config.sip.domain,
    socket: {
      ...sipConfig.socket,
      uri: config.sip.domain,
    },
    pcConfig: {
      ...sipConfig.pcConfig,
      iceServers,
    },
  });
};
